import { ohifActionsConstants } from "../constants";

const initialState = {};

const setStatus = (state, action) => {
  
  const {
          structIdNat,
          transferId,
          status,
          pacsId,
          kosUniqueId,
          studyInstanceUid,
          seriesInstanceUid
        } = action;
  
  const {
          [structIdNat]: {
            [pacsId]: {
              [kosUniqueId]: kosTransferStatus = {},
              ...restPacs
            } = {},
            ...restStruct
          } = {},
          ...restState
        } = state;
  
  return {
    [structIdNat]: {
      [pacsId]: {
        [kosUniqueId]: {
          ...kosTransferStatus,
          [seriesInstanceUid || studyInstanceUid]: {
            transferId,
            status
          }
        },
        ...restPacs
      },
      ...restStruct
    },
    ...restState
  };
};

export function ohifPacsTransfers (state = initialState, action) {
  switch (action.type) {
    case ohifActionsConstants.SET_PACS_TRANSFER_STATUS:
      return setStatus(state, action);
    default:
      return state;
  }
}
